import { Component, OnInit} from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router } from '@angular/router';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';
import {GlobalConstants} from 'src/app/global-constants'

@Component({
  selector: 'app-create-selections',
  templateUrl: './create-selections.component.html',
  styleUrls: ['./create-selections.component.scss'],
  providers: [SharedService]
})
export class CreateSelectionsComponent implements OnInit {

  constructor(
    private keycloakService: KeycloakService,
    private router: Router,
    private appConstants: AppConstants
  ) { }

  createComponentSelectionData : any = {}

  ngOnInit()
  {
    this.isLoading = true;
    this.createSelectionComponenetLoading()
  }


 async createSelectionComponenetLoading() {

   let createComponentSelectionData;
     const token = await this.keycloakService.getToken();
     createComponentSelectionData = {
       headers: {
         token: token,
         customerId: "",
       },
     }
     createComponentSelectionData['isOpen'] = true;
     createComponentSelectionData['certificatesEndPoint'] = this.appConstants.endPoints.certificatesEndPoint;
     createComponentSelectionData['processActionsEndPoint'] = this.appConstants.endPoints.processActionsEndPoint;
     createComponentSelectionData['sprigEndPoint'] = this.appConstants.endPoints.sprigEndPoint;
     createComponentSelectionData['scheduleApplicationID'] = GlobalConstants.scheduleApplicationID;
     this.createComponentSelectionData = { ...{}, ...createComponentSelectionData };
     this.getToken();
     setInterval(() => {
      this.getToken();
    }, 1000);
 }

 sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

 emitData(searchObj) {
  this.router.navigate(['/selection-creation-success']);
 }

 isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }


}
